import React from 'react';

/**
 * GridNav - A responsive grid for groups/topics/subtopics.
 * @param {Array} items - Array of items to display (groups, topics, or subtopics)
 * @param {Function} onItemClick - Callback when an item is clicked
 * @param {Function} getIcon - Optional function to get an icon for each item
 * @param {Function} getTopicCount - Optional function to get topic count for each item
 */

const GridNav = ({ items, onItemClick, getIcon, getTopicCount }) => {
  if (!Array.isArray(items)) {
    console.error('GridNav: items prop is not an array', items);
    return null;
  }
  return (
    <div className="w-full flex flex-col items-center">
      <div
        className="grid w-full justify-center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
      >
        {items.map((item) => (
          <button
            key={item.id}
            className="relative bg-white border border-gray-200 rounded-2xl shadow-sm p-6 flex flex-col items-center min-w-[220px] max-w-[320px] min-h-[260px] max-h-[360px] transition-shadow hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-purple-400 hover:bg-[#fff8e2]"
            onClick={() => onItemClick(item)}
            aria-label={item.title}
          >
            {getIcon && (
              <div className="mb-4 relative flex items-center justify-center" style={{ width: 101, height: 101 }}>
                {/* Icon background circle and icon */}
                <span className="w-[101px] aspect-square flex items-center justify-center rounded-full bg-white overflow-hidden" style={{ zIndex: 1 }}>
                  {getIcon(item)}
                </span>
                {/* Order number badge, only if parentGroupId exists */}
                {item.parentGroupId && (
                  <span
                    className="absolute"
                    style={{
                      bottom: 0,
                      right: 0,
                      minWidth: 22,
                      minHeight: 22,
                      transform: 'translate(30%, 30%)',
                      zIndex: 2,
                      fontSize: 'xx-large',
                      color: '#efb347',
                      fontWeight: 900,
                      fontStretch: 'expanded',
                      background: 'none',
                      border: 'none',
                      padding: 0,
                    }}
                    aria-label={`Order ${items.indexOf(item) + 1}`}
                  >
                    {items.indexOf(item) + 1}
                  </span>
                )}
              </div>
            )}
            <h2 className="text-lg font-semibold text-gray-900 text-center mb-6">
              {item.title}
            </h2>
            {item.description && (
              <p className="text-sm text-gray-600 text-center mb-4 line-clamp-2">
                {item.description}
              </p>
            )}
            {getTopicCount && getTopicCount(item) !== undefined && getTopicCount(item) > 0 && (
              <span className="mt-auto text-xs bg-purple-100 text-purple-700 px-3 py-1 rounded-full font-medium self-end">
                Topics: {getTopicCount(item)}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default GridNav;
